import { useState } from "react";
import { usePortal } from "@app/portal-sdk";
import { Alert, SectionCard, Stack, Typography } from "@app/ui-kit";
import Link from "@mui/material/Link";
import { errorMessage } from "../../lib/useApiQuery";

export const EXAMPLE_WORKBOOK_PATH = "/admin/channel-analytics/example-workbook.xlsx";
export const EXAMPLE_WORKBOOK_FILE = "Data_Collection_Templates_sample.xlsx";

/**
 * WBX-4: the example workbook at the portal level. The client's Templates card once offered it as "Download a filled
 * example", which read as that client's data filled in; it is the invented demo client's, the same file for everyone,
 * so it lives here with what BKDP keeps and shows (STORIES_WORKBOOK_EXPORT.md, decision 1). One sentence and one link.
 */
export const ChannelAnalyticsExample = () => {
  const { api } = usePortal();
  const [error, setError] = useState<string | null>(null);
  const download = async () => { setError(null); try { await api.download(EXAMPLE_WORKBOOK_PATH, EXAMPLE_WORKBOOK_FILE); } catch (e) { setError(errorMessage(e)); } };
  return (
    <SectionCard eyebrow="Example workbook" title="A completed workbook, for showing">
      <Stack spacing={1.5}>
        <Typography variant="body2" data-testid="example-sentence">A filled collection workbook for BKDP Anchor &amp; Fastener, the invented demo client. Use it to show a client what a completed workbook looks like; none of it is anyone's data.</Typography>
        <Link component="button" type="button" onClick={() => void download()} sx={{ fontWeight: 600, alignSelf: "flex-start" }} data-testid="example-download">Download the example workbook</Link>
        {error && <Alert severity="error" onClose={() => setError(null)}>{error}</Alert>}
      </Stack>
    </SectionCard>
  );
};
